import React from 'react';
import { Paper, Typography, TextField } from '@mui/material';

/**
 * Component for displaying and editing notes
 * 
 * @param {Object} props - Component props
 * @param {string} props.value - Current value of the notes
 * @param {Function} props.onChange - Function to call when notes change
 * @param {Object} props.multilineStyle - Style object for multiline TextField
 * @param {number} props.rows - Number of rows for the TextField (default: 2)
 * @param {string} props.label - Label for the TextField (default: "Notes")
 */
const NotesSection = ({
  value = '',
  onChange,
  multilineStyle,
  rows = 4,
  label = 'Notes'
}) => {
  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 0.5, 
        mb: 0.5, 
        borderRadius: '4px',
        boxShadow: 'none',
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.02)',
        },
      }}
    >
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 0.5, fontSize: '0.875rem' }}>
        {label}
      </Typography>
      <TextField
        label={label}
        value={value}
        onChange={onChange}
        fullWidth
        multiline
        rows={rows}
        margin="dense"
        size="small"
        sx={multilineStyle}
      />
    </Paper>
  );
};

export default NotesSection;
